import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { FiEye, FiEyeOff } from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";
import { resetPassword } from "../../actions/userActions";
import "./AuthScreen.css";

export default function ResetPasswordScreen() {
  const { token } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPw, setShowPw] = useState(false);
  const [showConfirmPw, setShowConfirmPw] = useState(false);
  const [localError, setLocalError] = useState("");

  const userResetPassword = useSelector(
    (state) => state.userResetPassword || {},
  );

  const { loading, error, success } = userResetPassword;

  useEffect(() => {
    if (success) {
      navigate("/profile", { replace: true });
    }
  }, [success, navigate]);

  const submitHandler = (e) => {
    e.preventDefault();
    setLocalError("");

    if (!token) {
      setLocalError("Reset token is missing or invalid");
      return;
    }

    if (password.length < 8) {
      setLocalError("Password must be at least 8 characters");
      return;
    }

    if (password !== confirmPassword) {
      setLocalError("Passwords do not match");
      return;
    }

    dispatch(resetPassword(token, password));
  };

  return (
    <section className="auth-shell">
      <div className="auth-card auth-card--narrow">
        <div className="auth-single">
          <div className="auth-panel auth-panel--form auth-panel--no-border">
            <h1 className="auth-title">Reset password</h1>

            {(localError || error) && (
              <div className="auth-alert">{localError || error}</div>
            )}

            {success && (
              <div className="auth-success">
                Your password has been reset successfully.
              </div>
            )}

            <form className="auth-form" onSubmit={submitHandler}>
              <div className="auth-field">
                <label htmlFor="password">New password*</label>

                <div className="auth-password-wrap">
                  <input
                    id="password"
                    type={showPw ? "text" : "password"}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    autoComplete="new-password"
                    required
                    minLength={8}
                  />

                  <button
                    type="button"
                    className="auth-eye"
                    onClick={() => setShowPw((s) => !s)}
                    aria-label={showPw ? "Hide password" : "Show password"}
                  >
                    {showPw ? <FiEyeOff /> : <FiEye />}
                  </button>
                </div>
              </div>

              <div className="auth-field">
                <label htmlFor="confirmPassword">Confirm password*</label>

                <div className="auth-password-wrap">
                  <input
                    id="confirmPassword"
                    type={showConfirmPw ? "text" : "password"}
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    autoComplete="new-password"
                    required
                    minLength={8}
                  />

                  <button
                    type="button"
                    className="auth-eye"
                    onClick={() => setShowConfirmPw((s) => !s)}
                    aria-label={
                      showConfirmPw ? "Hide password" : "Show password"
                    }
                  >
                    {showConfirmPw ? <FiEyeOff /> : <FiEye />}
                  </button>
                </div>
              </div>

              <button
                type="submit"
                className="auth-btn auth-btn--primary auth-btn--gold"
                disabled={loading}
              >
                {loading ? "Updating..." : "Reset password"}
              </button>

              <Link to="/login" className="auth-inline-link">
                Back to sign in
              </Link>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}
